export * as authentication from '@wix/auto_sdk_identity_authentication/meta';
export * as recovery from '@wix/auto_sdk_identity_recovery/meta';
export * as verification from '@wix/auto_sdk_identity_verification/meta';
export * as oauth from '@wix/auto_sdk_identity_oauth/meta';
export * as signOnPolicy from '@wix/auto_sdk_identity_sign-on-policy/meta';
